/**
 * Constants
 * */
export const moduleName = `seo`;

/**
 * Reducer
 * */

export default function reducer(state = {}, action) {
  const {type} = action;

  switch (type) {
    default:
      return state;
  }
}

/**
 * Selectors
 * */

export const seoSelector = (state) => state[moduleName];

/**
 * Action Creators
 * */
